<template>
  <div class="main download" style="margin-bottom: 40px">
    <div class="banner">
    </div>
    <div class="mainContent">
      <div class="home-part download">
        <div class="home-intro">
          <img class="multi-device" src="../assets/images/20180102/downloadpic@2x.png" alt="">
          <p class="home-intro-detail">{{ $t('intro') }}</p>
        </div>
        <div class="home-info">
          <p class="home-title">{{ $t('d-title') }}</p>
        </div>
        <div class="download-qrcode">
          <p>{{ $t('sub-intro1') }}</p>
          <p>{{ $t('sub-intro2') }}</p>
          <img src="../assets/images/20180419/Crait_download.png" alt="">
        </div>
        <div class="home-download">
          <a class="download-ios cur decoration" href="https://itunes.apple.com/app/id1227620003"></a>
          <a class="download-android cur decoration" href="https://www.craitapp.com/download/crait.apk"></a>
          <!--<a class="download-pc cur decoration" href="market://details?id=com.secrat.cloud"></a>-->
          <a class="download-google cur decoration" href="https://play.google.com/store/apps/details?id=com.secrat.cloud"></a>
          <a class="download-pc cur decoration" href="https://fs.craitapp.com/download/crait-setup.exe"></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: 'Crait | ' + this.$i18n.t('download'), // set a title
      meta: [{                 // set meta
        name: 'keyWords',
        content: this.$i18n.t('key-content')
      },
      {
        name: 'description',
        content: this.$i18n.t('description-content')
      }]
    }
  },
  data () {
    return {
      user: navigator.userAgent
    }
  },
  created () {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  },
  methods: {}
}
</script>

<style lang="scss">
  .download {
    .home-intro {
      .home-intro-detail {
        margin: 0.5rem auto;
        text-align: left;
      }
      .multi-device {
        width: 70vw;
        margin-top: 0.5rem;
        @media screen and (max-width: 760px){
          width: 90vw;
        }
      }
    }
    .download-qrcode {
      margin-top: 0.35rem;
      p {
        font-size: 0.3rem;
        color: #666;
        @media screen and (max-width: 760px) {
          font-size: 0.18rem;
          text-align: left;
          padding: 0 .1rem;
        }
      }
      img {
        margin: 0.75rem 0;
      }
    }
    .home-download {
      padding: 0.5rem auto;
      a {
        display: inline-block;
        width: 2.15rem;
        height: 0.6rem;
        margin-right: 0.1rem;
        vertical-align: middle;
        @media screen and (max-width: 760px){
          margin: 0.1rem 0;
        }
      }
      .download-android {
        background: url("../assets/images/new/download_android@2x.png") no-repeat center;
        background-size: cover;
        /*margin-bottom: 0;*/
      }
      .download-ios {
        background: url("../assets/images/new/download_ios@2x.png") no-repeat center;
        background-size: cover;
      }
      .download-google {
        background: url("../assets/images/20180102/download_googleplay@2x.png") no-repeat center;
        background-size: cover;
      }
      .download-pc {
        background: url("../assets/images/20180102/download_win@2x.png") no-repeat center;
        background-size: cover;
      }
    }
  }
  @media screen and (max-width: 760px){
    .home-part {
      padding: 0.3rem 0;
      .home-info {
        width: 95%;
        margin-bottom: 0.5rem;
        .home-title {
          font-size: 0.3rem;
        }
      }
      .home-intro {
        /*display: block;*/
        flex-direction: column-reverse;
        .tool-pic {
          padding: 0;
        }
        .home-intro-title {
          font-size: 0.2rem;
          width: 100%;
          line-height: 0.3rem;
        }
        .home-intro-detail {
          font-size: 0.16rem;
          width: 95%;
          line-height: 0.24rem;
        }
        .home-crait-advantage-intro, .secureCommunication {
          margin-left: 0.2rem;
          padding: 0;
        }
        .organization .home-intro-title {
          width: 100%;
        }
        .key-feature-lists {
          display: block;
        }
      }
      .home-intro:nth-of-type(3) {
        flex-direction: column;
      }
    }
    .download {
      .home-info {
        margin-bottom: 0;
      }
    }
  }
  .home-part {
    padding: 0.7rem 0 0;
    text-align: center;
  }
  .home-info {
    width: 70%;
    margin: 0 auto;
  }
  .home-profile {
    font-size: 0.18rem;
    /*color: #888;*/
    margin: 0.25rem auto 0;
    width: 78%;
  }
  .home-title {
    font-size: 0.5rem;
    color: #303030;
    font-weight: 600;
  }
  .home-intro {
    i {
      display: inline-block;
    }
    .home-intro-title {
      font-size: 0.4rem;
      width: 57%;
      line-height: 0.6rem;
    }
    .home-intro-detail {
      width: 67%;
      font-size: 0.3rem;
      color: #999;
      margin: 0.25rem 0 0.2rem;
      line-height: 0.42rem;
    }
  }
</style>



// WEBPACK FOOTER //
// Download.vue?ca440580